import type { FunctionalAccount, FunctionalAccountType } from "@/features/auth/types";

export const getFunctionalAccountLabel = (functionalAccountType: FunctionalAccountType): string => {
  const labels: Record<FunctionalAccountType, string> = {
    basic: "Basic Account",
    patient: "Patient",
    doctor: "Doctor",
    specialist: "Specialist",
    technician: "Technician",
    business_owner: "Business Owner",
  };

  return labels[functionalAccountType];
};

export const getFunctionalAccountDisplayName = (functionalAccount: FunctionalAccount): string => {
  const label = getFunctionalAccountLabel(functionalAccount.functional_account_type);
  const name = functionalAccount.display_name?.trim();

  if (!name || name === label) {
    return label;
  }

  return `${label} - ${name}`;
};
